import React, { useState, useEffect, useCallback } from "react";
import "../../styles/desktop/main.css";

import CampoImagem     from "../CampoImagem/campoimagem";
import Menu            from "../menu/menu";
import TextMain        from "../Texto Principal/textoMain";
import Agendamentos    from "../Agendamento/agendamento";
import Loader          from "../loader/loader";
import Exaustor        from "../Exaustores/exaustores";
import Eventos         from "../events/eventos";
import background      from "../../assets/img/background.png";
import pagina1         from "../../assets/img/Pagina01.jpg";
import pagina2         from "../../assets/img/Pagina02.png";

import Grupo01         from "../Campo Luzes/Terreo";
import Grupo02         from "../Campo Luzes/Intermediario";
import AlarmeModal     from "../Alarme/AlarmeModal";
import Subsolo         from "../Campo Luzes/Subsolos/subsolos";
import Fachada         from "../Campo Luzes/Fachada";
import ArCondicionado  from "../Ar Condicionados/ar";

import ChatBot         from "../Plus/ChatBot/chatbot";
import PLUS            from "../Plus/plus";
import Dispositivos    from "../Plus/Dispositivos/dispositivo";
import Gestao          from "../Gestao/gestao";
import Notificacao     from "../Notificacao/notificacao";

// ===================  APIs  ===============================
import getRegistrosEventos from "../../API/events/getRegistrosEventos";
import { getAlarmes } from "../../API/basic/getAlarmes";
// ==========================================================

// Hooks
import { useNodeRedWatcher } from '../../hooks/useNodeRedWatcher';
import { useCmdServerWatcher } from '../../hooks/useCmdServerWatcher';

/** Utilitário: resolve ou timeout em `ms` */
const fetchComTimeout = (ms, prom) =>
  Promise.race([prom, new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), ms))]);

const TIMEOUT_MS = 3500;
const POLL_MS    = 5000;

const Main = () => {
  // ---------- páginas / UI ----------
  const [paginaAtual, setPaginaAtual] = useState("Térreo");
  const [filtro, setFiltro]           = useState("Todos");
  const [loadingImage, setLoadingImg] = useState(false);
  const [imagemCentral, setImagemCentral] = useState(pagina1);

  // ---------- eventos / chamados ----------
  const [eventos,  setEventos]  = useState([]);
  const [chamados, setChamados] = useState([]);
  const [loadingEventos, setLoadingEventos] = useState(true);

  // ---------- alarmes (CAIXA D’ÁGUA + BOMBAS) ----------
  const [caixas,  setCaixas]  = useState([]);
  const [bombas,  setBombas]  = useState([]);
  const [alarmStatus, setAlarmStatus] = useState("ok"); // loading | ok | error

  // =====================================================
  // 1) ---- BUSCA DE EVENTOS + CHAMADOS -----------------
  // =====================================================
  const dadosSaoDiferentes = (a, b) => JSON.stringify(a) !== JSON.stringify(b);

  const carregarEventos = useCallback(async (forceReload = false) => {
    try {
      if (forceReload) setLoadingEventos(true);

      const [ev, ch] = await Promise.all([getRegistrosEventos()]);

      if (dadosSaoDiferentes(ch, chamados)) setChamados(ch);
    } catch (err) {
      console.error("Erro ao buscar eventos:", err);
    } finally {
      setLoadingEventos(false);
    }
  }, [eventos, chamados]);

  // =====================================================
  // 2) ---- BUSCA DE ALARMES -----------------------------
  // =====================================================
  const carregarAlarmes = useCallback(async () => {
    try {
      if (alarmStatus === "loading") setAlarmStatus("loading");
      const data = await fetchComTimeout(TIMEOUT_MS, getAlarmes());
      setCaixas(data[0] || []);
      setBombas(data[1] || []);
      setAlarmStatus("ok");
    } catch (err) {
      console.error("Falha ao buscar alarmes:", err);
      setAlarmStatus("error");
    }
  }, [alarmStatus]);

  // -----------------------------------------------------
  // ***** CICLO DE VIDA *********************************
  // -----------------------------------------------------
  useEffect(() => {
    // Eventos / chamados
    carregarEventos(true);
    const idEventos = setInterval(() => carregarEventos(false), 5000);

    // Alarmes
    carregarAlarmes();
    const idAlarmes = setInterval(carregarAlarmes, POLL_MS);

    return () => {
      clearInterval(idEventos);
      clearInterval(idAlarmes);
    };
  }, []);

  // =====================================================
  // 3) ---- HANDLERS DE UI ------------------------------
  // =====================================================
  const groupComponents = { [pagina1]: <Grupo01 />, [pagina2]: <Grupo02 /> };

  const trocarPagina = useCallback((pagina) => {
    if (["Agendamentos","Alarme","Exaustor","Gestao","Chatbot","PLUS"].includes(pagina)) {
      setImagemCentral("");
    }
    if (pagina === "history") setFiltro("Todos");
    setPaginaAtual(pagina);
  }, []);

  const renderGroup = () => groupComponents[imagemCentral] || groupComponents[paginaAtual] || null;

  const loaderImage = useCallback(() => {
    setPaginaAtual(pagina1);
    setLoadingImg(true);
    setTimeout(() => setLoadingImg(false), 1000);
  }, []);

  const trocarImagem = useCallback((img) => {
    if (imagemCentral !== img) {
      loaderImage();
      setImagemCentral(img);
    }
  }, [imagemCentral, loaderImage]);

  const {
    suggestOnlineLogin: suggestFromNodeRed,
    autoSwitchedBackOnline,
    clearSuggestion: clearNodeRedSuggestion,
    clearAutoSwitchedFlag,
    backendUnavailable,
  } = useNodeRedWatcher();

  const {
    shouldSuggestOnlineLogin: suggestFromCmd,
    clearCmdOnlineSuggestion,
  } = useCmdServerWatcher();

  const authMode = sessionStorage.getItem('authMode') || 'offline';
  const showOnlinePrompt = authMode === 'offline' && suggestFromCmd;

  console.log("clearNodeRedSuggestion:", clearNodeRedSuggestion, typeof clearNodeRedSuggestion);

  const handleAcceptOnlineLogin = () => {
    clearNodeRedSuggestion();
    clearCmdOnlineSuggestion();
    window.location.href = '/login'; // deixa o LoginWrapper decidir o fluxo
  };

  const handleDismissOnlinePrompt = () => {
    clearNodeRedSuggestion();
    clearCmdOnlineSuggestion();
  };

  // =====================================================
  // 4) ---- RENDER --------------------------------------
  // =====================================================
  return (
    <div id="divMain">
      {backendUnavailable && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            padding: '8px 16px',
            background: '#7f1d1d',
            color: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <span>
            Nenhum servidor está respondendo no momento. 
            Verifique a conexão.
          </span>
        </div>
      )}

      {showOnlinePrompt && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            padding: '8px 16px',
            background: '#1f2933',
            color: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <span>
            Conexão com a rede disponível. Deseja usar o modo online?
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={handleAcceptOnlineLogin}>
              Fazer login online
            </button>
            <button onClick={handleDismissOnlinePrompt}>
              Agora não
            </button>
          </div>
        </div>
      )}

      {/* Mensagem opcional quando voltou automaticamente pro online */}
      {autoSwitchedBackOnline && (
        <div
          style={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            padding: '8px 16px',
            background: '#16a34a',
            color: '#fff',
            borderRadius: 6,
            zIndex: 9999,
          }}
        >
          Voltamos a usar a conexão online automaticamente.
          <button
            style={{ marginLeft: 12 }}
            onClick={clearAutoSwitchedFlag}
          >
            Ok
          </button>
        </div>
      )}
      
      {loadingEventos && <Loader />}

      {/* --- MENU --- */}
      <Menu
        trocarPagina={trocarPagina}
        trocarImagem={trocarImagem}
        paginaAtual={paginaAtual}
        paginas={[pagina1, pagina2]}
        /* ▼ novos props, use-os como quiser no Menu */
        alarmStatus={alarmStatus}
        caixasAlarmes={caixas}
        bombasAlarmes={bombas}
      />

      {/* --- CONTEÚDO --- */}
      <div id="content" style={{ backgroundImage: `url(${background})` }}>
        <TextMain />

        {paginaAtual === "Gestao" ? (
          <Gestao />
        ) : (
          <div id="content-Central">
            {paginaAtual === "Agendamentos" ? (
              <Agendamentos />
            ) : paginaAtual === "Exaustor" ? (
              <Exaustor />
            ) : paginaAtual === "Chatbot" ? (
              <ChatBot />
            ) : paginaAtual === "history" ? (
              <Eventos
                filtro={filtro}
                eventos={eventos}
                loading={loadingEventos}
                atualizarLista={carregarEventos}
                chamados={chamados}
              />
            ) : paginaAtual === "PLUS" ? (
              <PLUS />
            ) : paginaAtual === "Dispositivos" ? (
              <Dispositivos />
            ) : paginaAtual === "Alarme" ? (
              /* ---------- agora passamos os dados já prontos ---------- */
              <AlarmeModal
                caixas={caixas}
                bombas={bombas}
                status={alarmStatus}
              />
            ) : paginaAtual === "Subsolo" ? (
              <Subsolo />
            ) : paginaAtual === "Fachada" ? (
              <Fachada />
            ) : paginaAtual === "Climatização" ? (
              <ArCondicionado />
            ) : (
              <>
                {imagemCentral && <CampoImagem imagem={imagemCentral} loadingImage={loadingImage} />}
                {renderGroup()}
              </>
            )}
          </div>
        )}
      </div>

      <Notificacao
        trocarPagina={trocarPagina}
        setFiltro={setFiltro}
        eventos={eventos}
      />
    </div>
  );
};

export default Main;